export default () => ({
  selectedTab: 1,
  init() {},
  toggle(nextTab) {
    if (this.selectedTab === nextTab) return;

    this.selectedTab = nextTab;
  }
});
